import { render } from "./SafetyTaskRecordList.vue?vue&type=template&id=11c0a142"
import script from "./SafetyTaskRecordList.vue?vue&type=script&lang=js"
export * from "./SafetyTaskRecordList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/attendance/task/SafetyTaskRecordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11c0a142"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11c0a142', __exports__)) {
    api.reload('11c0a142', __exports__)
  }
  
  module.hot.accept("./SafetyTaskRecordList.vue?vue&type=template&id=11c0a142", () => {
    api.rerender('11c0a142', render)
  })

}


export default __exports__